import { render, staticRenderFns } from "./position-list.vue?vue&type=template&id=38c1761d&scoped=true&"
import script from "./position-list.vue?vue&type=script&lang=js&"
export * from "./position-list.vue?vue&type=script&lang=js&"
import style0 from "./position-list.vue?vue&type=style&index=0&id=38c1761d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c1761d",
  null
  
)

export default component.exports